import {clearFeedbacksByName} from "../../helpers/forms";

function initBlacklistForm(formElement) {
	// Init form

	const blackListElement = formElement.querySelector('.content-editable-blacklist');

	blackListElement.addEventListener('keyup', () => {
		clearLineErrors();
	})

	blackListElement.addEventListener('paste', () => {
		console.log('Clearing paste');
		// Clear any pasted styling, we must wait a bit to make sure all elements have been pasted
		setTimeout(()=>{
			blackListElement.querySelectorAll('*').forEach(element => {
				element.setAttribute('style', '');
			})
		},16);
	})

	// Form methods
	return {
		formElement,
		formFields: [
			'blacklist',
		],
		inputs() {
			let blacklist = '';

			for (const child of blackListElement.children) {
				if (child.innerText === "\n" || child.nodeName === 'BR') {
					// Add new line only
					blacklist += "\n";
				} else {
					const lineValue = child.nodeType === Node.TEXT_NODE ?
						child.data : child.innerText
					// Add new line and content
					blacklist += "\n" + lineValue;
				}
			}

			return {
				blacklist,
			};
		},
		clearFeedbacks() {
			return clearFeedbacksByName(this.formElement, this.formFields);
		},
		clearLineErrors() {
			clearLineErrors();
		},
		displayWrongLine() {
			this.clearLineErrors();

			const error = blackListElement.querySelector('.blacklist-container .invalid-feedback')
			if (error.innerHTML) {
				// Get line number
				const lineNumber = error.innerText.split(':')[0].split(' ')[1];
				if (lineNumber) {
					const line = this.formElement
						.querySelector('.content-editable-blacklist')
						.children[lineNumber];

					line.classList.add('error-line');
					line.style = 'background-color: #ff0000aa';
				}
			}
		},
		postUrl() {
			return this.formElement.dataset.url;
		},
	};

	// Component methods
	function clearLineErrors() {
		formElement.querySelectorAll('.error-line').forEach(line => {
			line.style = '';
		});
	}
}

export {initBlacklistForm}
